import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

import 'swiper/css/bundle';
const gallerySlider = document.querySelector('.gallery-slider');
if (gallerySlider) {
    if (gallerySlider.classList.contains('gallery-sliderBig')) {
        const swiper = new Swiper('.gallery-slider', {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            speed: 1000,
            spaceBetween: 32,
            slidesPerView: 1,
            loopAddBlankSlides: false,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 1.55, 
                },
            },
            navigation: {
                nextEl: '.swiper-next-btnGallery',
                prevEl: '.swiper-prev-btnGallery',
            },
        });
    } else {
        const swiper = new Swiper('.gallery-slider', {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            speed: 1000,
            spaceBetween: 32,
            slidesPerView: 1,
            loopAddBlankSlides: false,
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 1.5,
                },
            },
            navigation: {
                nextEl: '.swiper-next-btnGallery',
                prevEl: '.swiper-prev-btnGallery',
            },
        });
    }
    
}
